import Constants from 'common/constants'

import {REDUX_GET_STUDENTS} from '../../General/ActionTypes/ReduxActionTypes'
import {
  ADD_SIBLINGS,
  ADD_STD_GENERAL_REMARKS,
  ADD_STD_SPORTS,
  ADD_STD_SPORTS_BY_ID,
  ADD_STD_SPORTS_REMARKS,
  ADD_STD_SUBJECTS_REMARKS,
  ADD_STUDENT,
  ASSIGN_EXAM,
  ASSIGN_HW,
  ASSIGN_TEST,
  CREATE_PREVIOUS_CLASS_HISTORY,
  DELETE_UPLOADED_FILE,
  DEL_HW_TEST_EXAM,
  DEL_STD_EXAM,
  DEL_STD_GENERAL_REMARKS,
  DEL_STD_HOMEWORK,
  DEL_STD_SPORTS_REMARKS,
  DEL_STD_SUBJECTS_REMARKS,
  DEL_STD_TEST,
  EMAIL_LOGIN_DETAILS,
  GENERATE_STUDENT_LIST_REPORT,
  GENERATE_STUDENT_LOGIN_REPORT,
  GET_ACADEMIC_RECORD,
  GET_COUNSELLOR_MENTORS,
  GET_DONARS_LIST,
  GET_FILE_TYPES,
  GET_HW_TEST_EXAM,
  GET_MONTH_WISE_STUDENT_DROPOUT_PDF,
  GET_NEW_ADMISSION_STUDENT,
  GET_PARENT_BY_ID,
  GET_PREVIOUS_CLASS_HISTORY,
  GET_SIBLING_INFO,
  GET_STD_ACADEMIC_RECORD,
  GET_STD_ALL_SPORTS,
  GET_STD_EXAM,
  GET_STD_EXAM_ACADEMIC_RECORD,
  GET_STD_FEE_RECORD,
  GET_STD_GENERAL_REMARKS,
  GET_STD_HW,
  GET_STD_HW_ACADEMIC_RECORD,
  GET_STD_LATEST_STD_NO,
  GET_STD_PREV_EXAM_ACADEMIC_RECORD,
  GET_STD_PUBLIC_REMARKS,
  GET_STD_REMARKS_SPORTS,
  GET_STD_SUBJECTS,
  GET_STD_SUBJECTS_REMARKS,
  GET_STD_TEST,
  GET_STD_TEST_ACADEMIC_RECORD,
  GET_STD_UNEXAM,
  GET_STD_UNHW,
  GET_STD_UNTEST,
  GET_STD_USER_ID,
  GET_STUDENT_BY_ID,
  GET_STUDENT_DROPOUT_PDF,
  GET_STUDENT_LIST,
  GET_STUDENT_MINI_PROFILE,
  GET_STUDENT_SUBJECT_COMBINATION,
  GET_UPLOADED_FILE,
  INACTIVATE_STUDENT,
  SMS_LOGIN_DETAILS,
  UPDATE_STD_GENERAL_REMARKS,
  UPDATE_STD_SPORTS_REMARKS,
  UPDATE_STD_SUBJECTS_REMARKS,
  UPDATE_STUDENT,
  UPDATE_STUDENT_SUBJECT_COMBINATION,
  UPDATE_UPLOADED_FILE_TYPE,
  UPLOAD_FILE,
} from './ActionTypes/ApiActionTypes'

export const getStudentById = (id, onSuccess, onFailure) => {
  return {
    type: GET_STUDENT_BY_ID,
    payload: {
      apiUrl: Constants.api_get_student(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getStudentSubjectCombination = (id, onSuccess, onFailure) => {
  return {
    type: GET_STUDENT_SUBJECT_COMBINATION,
    payload: {
      apiUrl: Constants.api_get_student_subject_combination(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateStudentSubjectCombination = (id, body, onSuccess, onFailure) => {
  return {
    type: UPDATE_STUDENT_SUBJECT_COMBINATION,
    payload: {
      apiUrl: Constants.api_update_student_subject_combination(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}
export const getParentByStudentId = (id, onSuccess, onFailure) => {
  return {
    type: GET_PARENT_BY_ID,
    payload: {
      apiUrl: Constants.api_get_student_parent(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getStudentAcademicById = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_ACADEMIC_RECORD,
    payload: {
      apiUrl: Constants.api_get_student_academics(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getStudentExamsAcademicById = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_PREV_EXAM_ACADEMIC_RECORD,
    payload: {
      apiUrl: Constants.api_get_student_academics_previous_exams(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const api_get_StudentAcademicExamsById = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_EXAM_ACADEMIC_RECORD,
    payload: {
      apiUrl: Constants.api_get_student_academics_exams(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const api_get_StudentAcademicHomeworkById = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_HW_ACADEMIC_RECORD,
    payload: {
      apiUrl: Constants.api_get_student_academic_homeworks(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const api_get_StudentAcademicTestsById = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_TEST_ACADEMIC_RECORD,
    payload: {
      apiUrl: Constants.api_get_student_academics_tests(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const addGeneralRemarks = (id, data, onSuccess, onFailure) => {
  return {
    type: ADD_STD_GENERAL_REMARKS,
    payload: {
      apiUrl: Constants.api_add_student_generalRById(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const addStudentSport = (data, onSuccess, onFailure) => {
  return {
    type: ADD_STD_SPORTS,
    payload: {
      apiUrl: Constants.api_add_student_sport,
      getString: '',
      useBaseURL: true,
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const addStudentSportById = (data, onSuccess, onFailure) => {
  return {
    type: ADD_STD_SPORTS_BY_ID,
    payload: {
      apiUrl: Constants.api_add_student_sport_by_id,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const addSubjectRemarks = (id, data, onSuccess, onFailure) => {
  return {
    type: ADD_STD_SUBJECTS_REMARKS,
    payload: {
      apiUrl: Constants.api_add_student_subjectRyId(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const addSportRemarks = (id, data, onSuccess, onFailure) => {
  return {
    type: ADD_STD_SPORTS_REMARKS,
    payload: {
      apiUrl: Constants.api_add_studentSportRemarksById(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const addSiblings = (data, onSuccess, onFailure) => {
  return {
    type: ADD_SIBLINGS,
    payload: {
      apiUrl: Constants.api_add_student_siblings,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
/** The student's Public remarks, for the student and their parents. */
export const getPublicRemarks = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_PUBLIC_REMARKS,
    payload: {
      apiUrl: Constants.api_get_student_public_remarks(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getGeneralRemarks = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_GENERAL_REMARKS,
    payload: {
      apiUrl: Constants.api_get_student_generalRById(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getLatestStudentNo = (onSuccess, onFailure) => {
  return {
    type: GET_STD_LATEST_STD_NO,
    payload: {
      apiUrl: Constants.api_get_student_number,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getSubjectRemarks = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_SUBJECTS_REMARKS,
    payload: {
      apiUrl: Constants.api_get_student_subjectRyId(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateGeneralRemarks = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_STD_GENERAL_REMARKS,
    payload: {
      apiUrl: Constants.api_update_student_generalRById(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateSubjectRemarks = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_STD_SUBJECTS_REMARKS,
    payload: {
      apiUrl: Constants.api_update_student_subjectRyId(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getStudentSportsById = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_REMARKS_SPORTS,
    payload: {
      apiUrl: Constants.api_get_student_sports_remarks(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const updateStudentSportsById = (id, body, onSuccess, onFailure) => {
  return {
    type: UPDATE_STD_SPORTS_REMARKS,
    payload: {
      apiUrl: Constants.api_update_student_sports_remarks(id),
      getString: '',
      body,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getStudentFeeById = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_FEE_RECORD,
    payload: {
      apiUrl: Constants.api_get_student_fees(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getStudentUserId = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_USER_ID,
    payload: {
      apiUrl: Constants.api_get_student_user_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getStudentSubjects = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_SUBJECTS,
    payload: {
      apiUrl: Constants.api_get_student_subjects(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getStudentList = (body, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_STUDENT_LIST,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_students,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: reduxUpdate ? REDUX_GET_STUDENTS : '',
      onFailure,
    },
  }
}
export const getStudentMiniProfile = (body, onSuccess, onFailure) => {
  return {
    type: GET_STUDENT_MINI_PROFILE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_student_mini_profile,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const inactivateStudent = (id, onSuccess, onFailure) => {
  return {
    type: INACTIVATE_STUDENT,
    payload: {
      apiUrl: Constants.api_inactivate_student(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: {},
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getFileTypes = (body, onSuccess, onFailure) => {
  return {
    type: GET_FILE_TYPES,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_student_file_types,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const getAllSports = (data, onSuccess, onFailure) => {
  return {
    type: GET_STD_ALL_SPORTS,
    payload: {
      apiUrl: Constants.api_get_student_sports,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const addStudent = (data, onSuccess, onFailure) => {
  return {
    type: ADD_STUDENT,
    payload: {
      apiUrl: Constants.api_create_student,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSiblingInfo = (body, id, onSuccess, onFailure) => {
  return {
    type: GET_SIBLING_INFO,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_student_siblings(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const uploadFile = (id, body, onSuccess, onFailure) => {
  return {
    type: UPLOAD_FILE,
    payload: {
      apiUrl: Constants.api_add_upload_file(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}

export const getUploadedFiles = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_UPLOADED_FILE,
    payload: {
      apiUrl: Constants.api_get_uploaded_student_file(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}

export const deleteUploadedFile = (body, onSuccess, onFailure) => {
  return {
    type: DELETE_UPLOADED_FILE,
    payload: {
      apiUrl: Constants.api_delete_uploaded_file,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}

export const updateUploadedFileType = (body, onSuccess, onFailure) => {
  return {
    type: UPDATE_UPLOADED_FILE_TYPE,
    payload: {
      apiUrl: Constants.api_update_uploaded_file_type,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}

export const fetchDescriptions = (id, onSuccess, onFailure) => {
  return {
    type: GET_HW_TEST_EXAM,
    payload: {
      apiUrl: Constants.api_get_student_descriptions(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getAssignedStdtest = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_TEST,
    payload: {
      apiUrl: Constants.api_get_student_tests(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getAssignedStdHw = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_HW,
    payload: {
      apiUrl: Constants.api_get_student_homework(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getAssignedStdExam = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_EXAM,
    payload: {
      apiUrl: Constants.api_get_student_exams(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getUnAssignedStdtest = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_UNTEST,
    payload: {
      apiUrl: Constants.api_get_student_tests_unassigned(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getUnAssignedStdHw = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_UNHW,
    payload: {
      apiUrl: Constants.api_get_student_homework_unassigned(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getUnAssignedStdExam = (id, onSuccess, onFailure) => {
  return {
    type: GET_STD_UNEXAM,
    payload: {
      apiUrl: Constants.api_get_student_exams_unassigned(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const destroyStudentRecords = (id, body, onSuccess, onFailure) => {
  return {
    type: DEL_HW_TEST_EXAM,
    payload: {
      apiUrl: Constants.api_delete_student_records(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}
export const destroyStudentHomeWork = (id, body, onSuccess, onFailure) => {
  return {
    type: DEL_STD_HOMEWORK,
    payload: {
      apiUrl: Constants.api_delete_student_homework(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}
export const destroyStudentTest = (id, body, onSuccess, onFailure) => {
  return {
    type: DEL_STD_TEST,
    payload: {
      apiUrl: Constants.api_delete_student_test(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}
export const destroyStudentExam = (id, body, onSuccess, onFailure) => {
  return {
    type: DEL_STD_EXAM,
    payload: {
      apiUrl: Constants.api_delete_student_exam(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}
export const destroyStudentGremarksRecords = (id, onSuccess, onFailure) => {
  return {
    type: DEL_STD_GENERAL_REMARKS,
    payload: {
      apiUrl: Constants.api_delete_student_general_remarks(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const destroyStudentSremarksRecords = (id, onSuccess, onFailure) => {
  return {
    type: DEL_STD_SUBJECTS_REMARKS,
    payload: {
      apiUrl: Constants.api_delete_student_subject_remarks(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const destroyStudentSportRemarks = (id, onSuccess, onFailure) => {
  return {
    type: DEL_STD_SPORTS_REMARKS,
    payload: {
      apiUrl: Constants.api_delete_student_sport_remarks(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateStudent = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_STUDENT,
    payload: {
      apiUrl: Constants.api_update_student_ById(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const insertExam = (id, data, onSuccess, onFailure) => {
  return {
    type: ASSIGN_EXAM,
    payload: {
      apiUrl: Constants.api_add_student_exams_assign(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const insertHomeWork = (id, data, onSuccess, onFailure) => {
  return {
    type: ASSIGN_HW,
    payload: {
      apiUrl: Constants.api_add_student_homework_assign(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const insertTest = (id, data, onSuccess, onFailure) => {
  return {
    type: ASSIGN_TEST,
    payload: {
      apiUrl: Constants.api_add_student_tests_assign(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const getNewAdmissionStudent = (body, onSuccess, onFailure) => {
  return {
    type: GET_NEW_ADMISSION_STUDENT,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_new_admission_student,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const generateLoginReport = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_LOGIN_REPORT,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_generate_student_login_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const smsLoginDetails = (data, onSuccess, onFailure) => {
  return {
    type: SMS_LOGIN_DETAILS,
    payload: {
      apiUrl: Constants.api_sms_login_details,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const emailLoginDetails = (data, onSuccess, onFailure) => {
  return {
    type: EMAIL_LOGIN_DETAILS,
    payload: {
      apiUrl: Constants.api_email_login_details,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const generateStudentListReport = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_LIST_REPORT,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_generate_student_list_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const getStudentDropoutPdf = (body, onSuccess, onFailure) => {
  return {
    type: GET_STUDENT_DROPOUT_PDF,
    payload: {
      apiUrl: Constants.api_get_student_dropout_pdf,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      onSuccess,
      onFailure,
    },
  }
}

export const getMonthWiseStudentDropoutPdf = (body, onSuccess, onFailure) => {
  return {
    type: GET_MONTH_WISE_STUDENT_DROPOUT_PDF,
    payload: {
      apiUrl: Constants.api_get_month_wise_student_dropout_pdf,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getPreviousClassHistory = (id, onSuccess, onFailure) => {
  return {
    type: GET_PREVIOUS_CLASS_HISTORY,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_class_history(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onFailure,
    },
  }
}

export const createPreviousClassHistory = (id, body, onSuccess, onFailure) => {
  return {
    type: CREATE_PREVIOUS_CLASS_HISTORY,
    payload: {
      apiUrl: Constants.api_create_class_history(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}

export const getDonarList = (body, onSuccess, onFailure) => {
  return {
    type: GET_DONARS_LIST,
    payload: {
      apiUrl: Constants.api_get_donars,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}

export const getAcademicRecord = (id, onSuccess, onFailure) => {
  return {
    type: GET_ACADEMIC_RECORD,
    payload: {
      apiUrl: Constants.api_get_academic_record(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getCounsellorMentors = (body, onSuccess, onFailure) => {
  return {
    type: GET_COUNSELLOR_MENTORS,
    payload: {
      apiUrl: Constants.api_get_counsellor_mentor,
      getString: '',
      body,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
